<template>
    <div id="app">
        <game-map></game-map>
        <game-menu v-if="event && team && menuOpen"></game-menu>
        <event-selection v-if="!event"></event-selection>
        <team-selection v-if="event && !team"></team-selection>
        <point v-if="point"></point>
        <finish v-if="!point && finished"></finish>
    </div>
</template>

<script>
    import {mapState, mapGetters} from 'vuex'

    import Menu from './menu.vue'
    import EventSelection from './event_selection.vue'
    import TeamSelection from './team_selection.vue'
    import Map from './map.vue'
    import Point from './point.vue'
    import Finish from './finish.vue'

    export default {
        components: {
            'game-menu': Menu,
            'event-selection': EventSelection,
            'team-selection': TeamSelection,
            'game-map': Map,
            'point': Point,
            'finish': Finish
        },
        data () {
            return {};
        },
        mounted() {
            const timer = document.getElementById('timer');

            this.interval = setInterval(() => {
                if (this.$store.state.teams.activeTeam && this.$store.state.events.activeEvent.timeLimit) {
                    // Get time left
                    let created = new Date(this.$store.state.teams.activeTeam.created);
                    let timeLimit = this.$store.state.events.activeEvent.timeLimit * 60000;
                    let seconds = Math.max(0, Math.round((created.getTime() + timeLimit - (new Date).getTime()) / 1000));

                    if (seconds === 0) {
                        this.$store.commit('OUT_OF_TIME');
                    }

                    // Format
                    if (seconds < 60) {
                        timer.style.color = 'red';
                    } else {
                        timer.style.color = 'black';
                    }

                    let hours = Math.floor(seconds / 3600);
                    seconds %= 3600;
                    let minutes = Math.floor(seconds / 60);
                    seconds %= 60;

                    if (seconds < 10) seconds = '0' + seconds;
                    if (minutes < 10) minutes = '0' + minutes;
                    if (hours < 10) hours = '0' + hours;

                    // Display
                    timer.style.display = 'block';

                    if (hours !== '00') {
                        timer.innerHTML = hours + ':' + minutes;
                    } else {
                        timer.innerHTML = minutes + ':' + seconds;
                    }
                } else {
                    timer.style.display = 'none';
                }
            }, 1000);
        },
        destroyed() {
            clearInterval(this.interval);
        },
        computed: {
            ...mapState({
                menuOpen: state => state.client.menuOpen,
                event: state => state.events.activeEvent,
                team: state => state.teams.activeTeam,
                point: state => state.points.activePoint,
                clientLatLng: state => state.client.latLng,
                clientLatLngAccuracy: state => state.client.latLngAccuracy,
                capturingMedia: state => state.client.capturingMedia,
                uploads: state => state.client.uploads,
                pointLocations: function (state) {
                    if (!state.events.activeEvent || state.teams.finished) {
                        return [];
                    }

                    /*
                    if (state.teams.outOfTime) {
                        const point = state.events.activeEvent.points[state.events.activeEvent.finishPoint];
                        const position = point.question.locationSpecific ? point.question.location : point.location;

                        return [{
                            latLng: L.latLng(position.latitude, position.longitude),
                            radius: position.radius,
                            point
                        }];
                    }
                    */

                    const locations = [];

                    state.events.activeEvent.points.forEach(point => {
                        // Skip visited points
                        if (this.visitedQuestions.indexOf(point.question._id) !== -1) {
                            return;
                        }

                        const position = point.question.locationSpecific ? point.question.location : point.location;

                        locations.push({
                            latLng: L.latLng(position.latitude, position.longitude),
                            radius: position.radius,
                            point
                        });
                    });

                    return locations;
                }
            }),
            ...mapGetters([
                'visitedQuestions',
                'finished'
            ])
        },
        watch: {
            clientLatLng: function (latLng) {
                if (this.point || !this.team) {
                    return;
                }

                for (let i = 0; i < this.pointLocations.length; ++i) {
                    if (latLng.distanceTo(this.pointLocations[i].latLng) < this.pointLocations[i].radius) {
                        this.$store.dispatch('setActivePoint', this.pointLocations[i].point);
                        break;
                    }
                }
            },
            uploads: function () {
                this.uploads.forEach((upload, index) => {
                    if (!upload.started) {
                        this.$store.dispatch('upload', index);
                    }
                });
            }
        }
    }
</script>

<style>
    /*@import '~bootstrap/dist/css/bootstrap.min.css';*/
</style>



// WEBPACK FOOTER //
// app.vue?2f96d4e6